<template>
  <div>
    <div v-if="help_instructions" class="relative">
      <div role="button" tabindex="0" class="cursor-pointer text-lg text-center text-black bg-gray-300 rounded py-2 lg:py-1 px-3 mb-2 flex justify-between items-center"
        aria-label="Click for more information"
        @click.prevent="toggleHelp"
        @keydown.enter="toggleHelp"
        @keydown.space="toggleHelp"
      >
        <div class="flex items-center">
          <div class="pl-1 mr-3 hidden lg:block">
            <i aria-hidden="true" class="material-icons leading-tight text-4xl">info</i>
          </div>

          <div class="flex-1 pl-1 pr-3 text-left lg:text-center font-bold" role="heading" aria-level="1">{{ name }}</div>
        </div>

        <div class="flex flex-none items-center">
          <div class="flex-none text-xs pl-3 -mr-2"
            :class="active ? 'text-transparent' : 'text-gray-800'"
          >
            More information
          </div>

          <div class="flex-none relative h-10 w-16 pl-3 text-right leading-tight">
            <transition name="fade">
              <span class="absolute w-full top-0 right-0 pt-1" v-show="!active"><i aria-hidden="true" class="material-icons">menu_book</i><i aria-hidden="true" class="material-icons leading-tight text-2xl p-0">expand_more</i></span>
            </transition>

            <transition name="fade">
              <span class="absolute w-full top-0 right-0 pt-1 text-red-800" v-show="active"><i aria-hidden="true" class="material-icons leading-tight">cancel</i></span>
            </transition>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div
          v-show="active"
          :aria-expanded="active ? 'true' : 'false'"
          class="absolute bg-gray-100 -mt-3 px-5 py-4 rounded-b shadow z-50"
        >
          {{ help_instructions }}
        </div>
      </transition>        
    </div>
    <h1 v-else-if="name" class="text-lg text-center text-black bg-gray-300 rounded py-2 lg:py-1 px-3 mb-2 flex justify-between items-center">
      <button type="button" class="h-10 bg-transparent p-0"
        @click="togglePopout"
      >
        <i class="material-icons text-4xl text-black hover:text-yellow-600">info</i>
      </button>
      <span class="m-auto">{{ name }}</span>
    </h1>
    <div v-show="popoutHidden" class="help-slideout-button">
        <button type="button" v-on:click="togglePopout" class="btn-transparent p-0"><i aria-hidden="true" class="material-icons text-3xl md:text-4xl">help</i></button>
        <button type="button" v-on:click="togglePopout" class="btn-transparent p-0 menu-bottom"><i aria-hidden="true" class="material-icons text-3xl md:text-4xl">menu</i></button>
    </div>
    <transition name="slide">
      <div v-if="!popoutHidden" class="help-slideout w-72 lg:w-96" v-click-outside="onClickOutside">
        <button type="button"
          @click="popoutHidden = true"
          ref="closeButton"
          class="btn-transparent p-0 text-indigo-600 hover:text-indigo-700 focus:text-white h-12 absolute top-0 left-0 p-1"
        ><i aria-hidden="true" class="material-icons text-xl md:text-2xl">close</i></button>
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
export default {
  props: {
    name: '',
    help_instructions: '',
    icon: '',
  },

  data() {
    return {
      popoutHidden: true,
      success: false,
      loaded: true,
      active: false,
    }
  },

  directives: {
    clickOutside: vClickOutside.directive
  },

  methods: {
    onClickOutside (event) {
      this.togglePopout();
    },
    togglePopout() {
      this.popoutHidden = ! this.popoutHidden;

      if (! this.popoutHidden) {
        console.log('focus...');

        this.$nextTick(() => {
          this.$refs.closeButton?.focus();
        })
      }
    },
    toggleHelp() {
      this.active = ! this.active;
    },
  }
}
</script>
